import { BiBlendJoin } from '@euler/model/bi/blend';
import { memo } from 'react';
import { BiChip } from '../../../components/ui/BiChip';
import { EditorSection } from '../EditorSection';
import { kBiBlendJoinLabels } from '../functions/biEditorLabels';

const kJoins = Object.values(BiBlendJoin);

/** Which merged rows the card keeps when a key is on one side only. */
export const BlendJoinSection = memo(
  ({
    join,
    onChange,
  }: {
    join: BiBlendJoin;
    onChange: (next: BiBlendJoin) => void;
  }) => (
    <EditorSection
      title="合并方式"
      note="关联字段的某个值只有一边有数据时"
      wrap
    >
      {kJoins.map(entry => (
        <BiChip
          key={entry}
          label={kBiBlendJoinLabels[entry]}
          selected={join === entry}
          onPress={() => onChange(entry)}
        />
      ))}
    </EditorSection>
  ),
);
